import { useMutation } from "react-query";
import http from "infra/http";

function useDuplicarRelatorioPrestacaoContas() {
  return useMutation(
    (id: string) => {
      return http.post<{ id: string; nome: string }>(
        `/v1/relatorios/financeiro/prestacao-contas/${id}/duplicar`
      );
    },
    { retry: false }
  );
}

export default useDuplicarRelatorioPrestacaoContas;
